import React from 'react'

import { MainStyle } from './styles'

function Main(props) {
  return <MainStyle {...props} />
}

export default Main
